import BusinessProfileWrapper from './BusinessProfileWrapper';

export default BusinessProfileWrapper;
